import React from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

export default function CancelButton({ orderId, onCancel }) {
  const handleCancelClick = () => {
    Swal.fire({
      title: `<h4>Are you sure you want to cancel this order?</h4>`,
      text: "Once cancelled, this action cannot be reverted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, cancel it!",
      customClass: {
        title: "swal-custom-title",
        icon: "swal-custom-icon",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        onCancel(orderId);
      }
    });
  };

  return (
    <button
      className="cancel-button btn btn-danger mt-5"
      onClick={(e) => {
        e.preventDefault();
        handleCancelClick();
      }}
    >
      CANCEL
    </button>
  );
}
